import AcxSelectMulti from "components/UI/Select/BaseSelectComponents/AcxSelectMulti";
import { observer } from "mobx-react";
import React from "react";
import { Language } from "stores/ApplicationFilters/Filters/Language";
import { IApplicationFilterComponent } from "../BaseFilterComponents/IApplicationFilterComponent";
import { useRestrictedOptions } from "../BaseFilterComponents/useRestrictedOptions";
import { usePruneSelectedValues } from "../BaseFilterComponents/usePruneSelectedValues";

export const LanguageFilter = observer(function (
    props: IApplicationFilterComponent,
) {
    const { availableOptions, hasRestrictions, isValueAllowed } =
        useRestrictedOptions({
            options: props.store.languageOptions,
            getOptionValue: (option) => option.value,
            optionRestriction: props.optionRestriction,
            restrictedValues: props.restrictedValues,
        });

    usePruneSelectedValues({
        selectedValues: props.store.languages,
        setSelectedValues: (languages) => props.store.setLanguages(languages),
        isValueAllowed: (language) => isValueAllowed(language.languageValue),
        enabled: hasRestrictions,
    });

    const selectedOptions = props.store.languages
        .map((language) =>
            availableOptions.find(
                (option) => option.value === language.languageValue,
            ),
        )
        .filter((option): option is (typeof availableOptions)[number] =>
            Boolean(option),
        )
        .map((option) => ({
            label: option.label,
            id: option.id as number,
            value: option.value as Language,
        }));

    return (
        <AcxSelectMulti
            id={props.id ?? props.filterKey}
            fullWidth
            options={availableOptions}
            defaultValue={selectedOptions}
            onChange={(options) => {
                const newOptions = options?.map((x) => {
                    return {
                        languageValue: x.value,
                        localeId: x.id as number,
                    };
                });

                props.store.setLanguages(!!newOptions ? newOptions : []);
            }}
            valueField="id"
            labelField="label"
            containerHeight="auto"
            maxContainerHeight="96px"
            alignControls="flex-start"
            isClearable={true}
        />
    );
});
